<main class="main">
    <router-outlet></router-outlet>
    <app-loading></app-loading>
</main>
